'use strict';

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularCookies = require('angular-cookies');

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _angularResource = require('angular-resource');

var _angularResource2 = _interopRequireDefault(_angularResource);

var _angularSanitize = require('angular-sanitize');

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

require('angular-socket-io');

require('ngStorage');

var _ngCsv = require('ng-csv');

var _ngCsv2 = _interopRequireDefault(_ngCsv);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _angularUiBootstrap = require('angular-ui-bootstrap');

var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);

var _app = require('./app.config');

var _auth = require('../components/auth/auth.module');

var _auth2 = _interopRequireDefault(_auth);

var _account = require('./account');

var _account2 = _interopRequireDefault(_account);

var _admin = require('./admin');

var _admin2 = _interopRequireDefault(_admin);

var _navbar = require('../components/navbar/navbar.component');

var _navbar2 = _interopRequireDefault(_navbar);

var _footer = require('../components/footer/footer.component');

var _footer2 = _interopRequireDefault(_footer);

var _main = require('./main/main.component');

var _main2 = _interopRequireDefault(_main);

var _homeowner = require('./homeowner/homeowner.component');

var _homeowner2 = _interopRequireDefault(_homeowner);

var _app2 = require('./app.constants');

var _app3 = _interopRequireDefault(_app2);

var _util = require('../components/util/util.module');

var _util2 = _interopRequireDefault(_util);

var _socket = require('../components/socket/socket.service');

var _socket2 = _interopRequireDefault(_socket);

require('../components/services');

var _application = require('./application/application.component');

var _application2 = _interopRequireDefault(_application);

var _telFilter = require('./filters/tel/tel.filter.js');

var _telFilter2 = _interopRequireDefault(_telFilter);

require('./configFile.js');

require('./app.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = require('debug')('fifi:app');

_angular2.default.module('parkingFormApp', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, _ngCsv2.default, 'ngStorage', 'btford.socket-io', _angularUiRouter2.default, _angularUiBootstrap2.default, _auth2.default, _account2.default, _admin2.default, _navbar2.default, _footer2.default, _main2.default, _homeowner2.default, _app3.default, _socket2.default, _application2.default, _util2.default, require('angular-stripe'), require('angular-credit-cards'), require('angular-ui-mask'), require('angular-loading-bar'), require('angular-scroll'), 'parkingformApp.services', _telFilter2.default, require('angular-moment')]).config(_app.routeConfig).config(['EnvironmentConfig', 'stripeProvider', function (EnvironmentConfig, stripeProvider) {
  stripeProvider.setPublishableKey(EnvironmentConfig.stripeKey);
  debug(EnvironmentConfig.environment);
}]).run(function ($rootScope, $location, Auth) {
  'ngInject';

  $rootScope.$on('$stateChangeStart', function (event, next) {
    Auth.isLoggedIn(function (loggedIn) {
      if (next.authenticate && !loggedIn) {
        $location.path('/login');
      }
    });
  });
}).run(function ($rootScope, $state) {
  'ngInject';

  $rootScope.$on('$stateChangeStart', function (evt, to, params) {
    if (to.redirectTo) {
      evt.preventDefault();
      $state.go(to.redirectTo, params);
    }
  });
});

_angular2.default.element(document).ready(function () {
  _angular2.default.bootstrap(document, ['parkingFormApp'], {
    strictDi: true
  });
});


// WEBPACK FOOTER //
// ./client/app/app.js